export default function Wordmark({ compact = false }) {
  return (
    <a className={compact ? 'wordmark wordmark--compact' : 'wordmark'} href="/" aria-label="Stefan Maldet Home">
      <span>Stefan</span>
      <span>Maldet</span>
    </a>
  );
}
